import { type ComponentProps, memo } from 'react';

import { Skeleton } from '@air/component-skeleton';
import { cn } from '@air/utils-tailwind';

export type AssetVersionSkeletonThumbnailProps = Omit<ComponentProps<'div'>, 'children'>;

export const AssetVersionSkeletonThumbnail = memo(
  ({ className, ...restOfProps }: AssetVersionSkeletonThumbnailProps) => {
    return (
      <div
        className={cn('h-10 w-[72px] shrink-0 overflow-hidden rounded-4 ads:bg-subtle bg-gray-1', className)}
        data-testid="ASSET_VERSION_SKELETON_THUMBNAIL"
        {...restOfProps}
      >
        <Skeleton className="size-full ads:text-ads-gray-3 text-gray-6" />
      </div>
    );
  },
);

AssetVersionSkeletonThumbnail.displayName = 'AssetVersionSkeletonThumbnail';
